import { html, ref, when, Observable } from '@microsoft/fast-element';
import { eventDetail } from '../../utils/formatting';
import type { MarketDepth } from './market-depth';
import { whiteCheckIconTwo, whiteErrorIconTwo } from '../../styles';
import { PROFILE_RIGHTS } from '../../utils';

export const MarketDepthTemplate = html<MarketDepth>`
  <div class="cascade-route-content">
    <div class="market-depth">
      <div class="grid-card">
        <zero-card class="no-padding-card">
          <zero-tabs>
            <span slot="start" class="tab-title">Market Depth</span>
            <tab-buttons slot="end" style="display: ${(x) => (x.rfq ? '' : 'none')}">
              <zero-button
                slot="buttons"
                appearance="chat-reject"
                class="market-depth-button-style"
                @click=${(x) => x.cancelVppaSelection()}
              >
                ${whiteErrorIconTwo('start')} ${(x) => 'Cancel'}
              </zero-button>
              ${when(
                (x) => x.authService.validateProfile(PROFILE_RIGHTS.UPSERT_NEGOTIATION),
                html`
                  <zero-button
                    slot="buttons"
                    appearance="chat-accept"
                    @click="${(x) => x.sendNegotiations()}"
                    class="market-depth-button-style"
                    slot="actions"
                    ?disabled="${(x) => !x.isVppaSelected}"
                  >
                    ${whiteCheckIconTwo('start')} ${(x) => 'Create Proposal'}
                  </zero-button>
                `
              )}
            </tab-buttons>
          </zero-tabs>
          <div class="card-body">
            <market-depth-query
              class="market-depth-query"
              :criteria="${(x) => x.marketDepthService.criteriaList}"
              :contractTypes="${(x) => x.contractTypes}"
              @updateMethodOfExecution="${(x, c) => x.methodOfExecutionUpdated(eventDetail(c))}"
            ></market-depth-query>
            <market-depth-grid
              style="display: ${(x) => (!x.rfq ? '' : 'none')}"
              :criteria="${(x) => x.marketDepthService.criteriaList}"
              :methodOfExecution="${(x) => x.methodOfExecution}"
              @createProposal="${(x, c) => x.getStructuredChat(eventDetail(c))}"
              @createVppaProposal="${(x, c) => x.getVppaList(eventDetail(c))}"
              @deleteVppa="${(x, c) => x.deleteVppa(eventDetail(c))}"
              @deleteRfq="${(x, c) => x.deleteRfq(eventDetail(c))}"
              @editVppa="${(x, c) => x.editVppa(eventDetail(c))}"
              @editRfq="${(x, c) => x.editRfq(eventDetail(c))}"
            ></market-depth-grid>
            <market-depth-vppa-grid
              ${ref('marketDepthVppaGridElement')}
              style="display: ${(x) => (x.rfq ? '' : 'none')}"
              :rfq="${(x) => x.rfq}"
              @vppaSelected="${(x, c) => x.vppaSelected(eventDetail(c))}"
            ></market-depth-vppa-grid>
          </div>
        </zero-card>
      </div>
    </div>
  </div>
  <vppa-modal ${ref('vppaModal')}></vppa-modal>
  <rfq-modal ${ref('rfqModal')}></rfq-modal>
  <cancel-modal
    ${ref('cancelModal')}
    @confirmCancel="${(x, c) =>
      x.isVPPA ? x.cancelVppa(eventDetail(c)) : x.cancelRfq(eventDetail(c))}"
  ></cancel-modal>
`;
